/**
 *  device-mode.js
 *      Generates Tailwind classes for the device preview modes in the Flex editor.
 */

const screenUtils = require('../utils/devices');
const tailwindScreens = require('../../tailwind.screens');

module.exports.variant = function deviceModePlugin({ addVariant, e }) {
    addVariant('device-mode', ({ modifySelectors, separator }) => {
        modifySelectors(({ className }) => {
            const screens = Object.keys(tailwindScreens);
            const states = ['hover']; // removing "active" and "focus" until they are needed, in order to keep the file size down
            const customStates = ['selected', 'expanded', 'matching'];
            const classes = [];

            screens.forEach((screen) => {
                const bodyClass = screenUtils.deviceClasses[screen];
                const screenClass = e(`${ screen }${ separator }${ className }`);

                // sample output = .#{ $is-mobile } .mob\:f-text-blue-500
                classes.push(`.${ bodyClass } .${ screenClass }`);

                states.forEach((state) => {
                    const screenStateClass = `${ e(`${ screen }${ separator }${ state }${ separator }${ className }`) }:${ state }`;

                    // sample output = .#{ $is-mobile } .mob\:hover\:f-text-blue-500:hover
                    classes.push(`.${ bodyClass } .${ screenStateClass }`);
                });

                customStates.forEach((state) => {
                    const screenStateClass = e(`${ screen }${ separator }${ state }${ separator }${ className }`);

                    // sample output = .#{ $is-mobile } .mob\:selected\:f-text-blue-500
                    // we assume that all "custom states" have an accompanying "is-{state}" class
                    classes.push(`.${ bodyClass } .is-${ state }.${ screenStateClass }`);
                });
            });

            return classes;
        });
    });
};
